import { colors } from '../style/colors';
export const tabStyles = {
    fontFamily: 'Titillium Web',
    textTransform: 'inherit',
    fontSize: 'inherit',
    minHeight: '44px',
    color: `${colors.gray['400']} !important`
};
//# sourceMappingURL=styles.js.map